/* eslint import/no-webpack-loader-syntax: off */

import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import Terminal from "components/terminal/terminal2"

const ModalExample = (props) => {

    const [modal, setmodal] = useState(false);
    const [device, setDevice] = useState([])
    useEffect(() => {
        if (props.device) {
            setDevice(props.device)
        }
    }, [props.device])
        return (
            <div>
                <Button className="c-primary" onClick={() => setmodal(!modal)}>
                    Terminali Başlat
                </Button>
                <Modal
                    isOpen={modal}
                    toggle={() => setmodal(!modal)}
                    style={{maxWidth:"700px"}}
                >
                    <ModalHeader toggle={() => setmodal(!modal)}>Modal title</ModalHeader>
                    <ModalBody>
                        <Terminal deviceAttributes={device}/>
                    </ModalBody>
                    {/*
                    <ModalFooter>
                        <Button className="c-primary" onClick={() => setmodal(!modal)}>
                            Do Something
                        </Button>{" "}
                        <Button className="c-secondary" onClick={() => setmodal(!modal)}>
                            Cancel
                        </Button>
                    </ModalFooter>
                    */}
                </Modal>
            </div>
        );
    }

export default ModalExample;
